import { render, staticRenderFns } from "./MessageCardWithFml.vue?vue&type=template&id=1c05e098&"
import script from "./MessageCardWithFml.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageCardWithFml.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MessageCardWithFml.vue?vue&type=style&index=0&id=1c05e098&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports